'use client'

import { Box, Stack } from '@mantine/core'
import { useTranslations } from 'next-intl'
import FormTextField from '@app/components/form/FormTextField'
import { RegisterMedicalFormValues } from '@lib/schemas/auth-schema'
import { MultistepForm } from '../../../../components/Multistep'
import ProfileImageStep from '../../../components/auth/ProfileImageStep'

interface Props {
    form: MultistepForm<RegisterMedicalFormValues>
}

export default function PersonalDetailsStep({ form }: Props) {
    const t = useTranslations('auth.register.personal')
    const {
        register,
        formState: { errors }
    } = form

    return (
        <Stack gap='lg'>
            <FormTextField
                name='email'
                register={register}
                label={t('email')}
                placeholder={t('emailPlaceholder')}
                required
                error={errors.email?.message}
            />
            <FormTextField
                name='firstName'
                register={register}
                label={t('firstName')}
                placeholder={t('firstNamePlaceholder')}
                required
                error={errors.firstName?.message}
            />
            <FormTextField
                name='lastName'
                register={register}
                label={t('lastName')}
                placeholder={t('lastNamePlaceholder')}
                required
                error={errors.lastName?.message}
            />

            <Box component='section' aria-label={t('profileImage')} mt='xs'>
                <ProfileImageStep form={form} showDescription={false} />
            </Box>
        </Stack>
    )
}
